import { createFileRoute, redirect } from "@tanstack/react-router";
import { runsSearchSchema } from "@/features/automation/runs-page";

/** ALP-84: "Run history" is now the "Automation log". The page keeps its URL `/automation/runs`; `/automation/log` is an alias. */
export const Route = createFileRoute("/_app/automation/log")({
  validateSearch: runsSearchSchema,
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/automation/runs", search, replace: true });
  },
});
